<template>
  <div class="text-left">
    <div class="row">
      <div class="col-sm-12">
        <h3 class="font-weight-bolder mt-2">Assessment Report</h3>
      </div>
      <div class="col-sm-12">
        <table class="table table-hover table-bordered table-template-1 table-layout-fixed text-small">
          <thead>
          <tr>
            <th :class="{ 'col-index': !printMultipleParams.active, 'col-index-md': printMultipleParams.active}">
              <input type="checkbox"
                     v-if="printMultipleParams.active"
                     @change="selectDocuments"
                     :checked="allSelected"
              >
              #
            </th>
            <th class="col-code">Code</th>
            <th style="width: 25%;">Name</th>
            <th class="col-date-time">Conduct Date</th>
            <th class="col-date-time">Place</th>
            <th style="width: 30%;">Vessel</th>
            <th class="col-date-time">Last Updated</th>
            <th style="width: 200px;">Action</th>
          </tr>
          </thead>
          <tbody>

          <tr v-if="isLoading">
            <td colspan="100%">
              <app-loading></app-loading>
            </td>
          </tr>

          <template v-else>
            <tr v-for="(crewAssessment, index) in crewAssessments"
                :key="crewAssessment.documentId"
                :class="{'bg-success' :
                          (crewAssessment.id && printMultipleParams.selectedCrewDocuments.assessments.includes(crewAssessment.id)) && printMultipleParams.active}"
            >

              <td class="text-right">
                <input type="checkbox" name="crew-document-selection"
                       v-if="printMultipleParams.active && crewAssessment.hasFile"
                       :value="crewAssessment.id"
                       v-model="printMultipleParams.selectedCrewDocuments.assessments"
                >
                {{ index + 1 }}
              </td>
              <td class="col-code">{{ crewAssessment.documentCode }}</td>
              <td class="col-code">{{ crewAssessment.documentName }}</td>
              <td class="col-date-time">{{ crewAssessment.conduct_date | moment('DD MMM Y') }}</td>
              <td class="col-code">{{ crewAssessment.place }}</td>
              <td class="col-code">{{ crewAssessment.vessel }}</td>
              <td class="col-date-time">{{ crewAssessment.updatedAt | moment('DD MMM Y') }}</td>
              <td class="text-center">
                <button class="btn btn-sm btn-xs btn-outline-info mr-2"
                        v-if="crewAssessment.id"
                        data-toggle="modal"
                        data-target="#viewCrewAssessment"
                        @click="updateAssessmentModal(crewAssessment)"
                >
                  <span class="fas fa-eye"></span>
                  View
                </button>
                <template v-if="(crew.active == 1 || isSystemAdmin) && !isKline">
                  <button class="btn btn-sm btn-xs btn-outline-primary mr-2"
                          style="opacity: 0.75"
                          data-toggle="modal"
                          data-target="#newCrewAssessment"
                          @click="refreshNewCrewAssessment(crewAssessment)"
                          v-if="(isDesignatedPrincipal || isPrincipal || isPrincipalStaff) || (crewAssessment.documentId !== 166 && ((isDesignatedManning || isPrincipalStaff) && !guest))"
                  >
                    <span class="fas fa-file-alt"></span>
                    {{ crewAssessment.id ? 'Renew' : 'Upload' }}
                  </button>
                </template>
              </td>
            </tr>
          </template>

          </tbody>

        </table>
      </div>
    </div>

    <div class="modal fade"
         id="viewCrewAssessment"
         tabindex="-1"
         role="dialog"
         aria-labelledby="viewCrewAssessmentTitle"
         aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-body text-small full-modal-body-height" v-if="crewAssessment.id">

            <div class="row">
              <div class="col col-sm-4">
                <div class="row">
                  <form class="col col-sm-12" @submit.prevent="confirmUpdateCrewAssessment">

                    <div class="form-group form-row mb-1" :class="{'has-error': crewAssessmentError.conduct_date}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="conductDate">
                        Conduct Date:
                      </label>

                      <div class="col col-sm-8">
                        <input type="date" id="conductDate"
                               class="form-control form-control-xs"
                               v-model="crewAssessment.conduct_date"
                               v-if="editable"
                        >
                        <input type="text"
                               class="form-control form-control-xs"
                               :value="crewAssessment.conduct_date | moment('D MMM YYYY')"
                               placeholder="NOT SPECIFIED"
                               readonly
                               v-else
                        >
                        <span class="help-block" v-if="crewAssessmentError.conduct_date !== ''">
                                                    <small><strong>{{
                                                        crewAssessmentError.conduct_date
                                                      }}</strong></small>
                                                </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': crewAssessmentError.place}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="place">
                        Place:
                      </label>

                      <div class="col col-sm-8">

                        <select id="place"
                                v-if="editable"
                                class="form-control form-control-sm"
                                v-model="crewAssessment.place"
                        >
                          <option :value="''">--- Select Place ---</option>
                          <option v-for="(assessmentReportPlace, index) in assessmentReportPlaces" :key="index"
                                  :value="assessmentReportPlace"
                          >{{ assessmentReportPlace }}
                          </option>
                        </select>
                        <input type="text" id="place" readonly
                               v-else
                               class="form-control form-control-xs"
                               placeholder="NO SPECIFIED PLACE"
                               v-model="crewAssessment.place"
                        >

                        <!--                                                <input type="text" id="place"-->
                        <!--                                                       class="form-control form-control-xs"-->
                        <!--                                                       placeholder="Enter Conducted Place Here"-->
                        <!--                                                       v-model="crewAssessment.place"-->
                        <!--                                                       :readonly="!editable"-->
                        <!--                                                >-->
                        <span class="help-block" v-if="crewAssessmentError.place !== ''">
                                                    <small><strong>{{ crewAssessmentError.place }}</strong></small>
                                                </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': crewAssessmentError.vessel_id}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="vessel_id">
                        Vessel:
                      </label>

                      <div class="col col-sm-8">

                        <VesselDropdown
                            v-if="editable"
                            id="vessel_id"
                            v-model="crewAssessment.vessel_id"
                            :selections="vesselKeys"
                            identifier="vessel"
                            :other-function="getOtherVesselKeys"
                        ></VesselDropdown>

                        <!--                                                <DropdownSelect id="vessel_id" v-if="editable"-->
                        <!--                                                                style="width: 80%"-->
                        <!--                                                                identifier="vessel"-->
                        <!--                                                                :selections="vesselKeys"-->
                        <!--                                                                :other-function="getOtherVesselKeys"-->
                        <!--                                                                @updateVessel="crewAssessment.vessel_id = $event"-->
                        <!--                                                ></DropdownSelect>-->

                        <!--                                                <select id="vessel_id"-->
                        <!--                                                        v-if="editable"-->
                        <!--                                                        class="form-control form-control-sm"-->
                        <!--                                                        v-model="crewAssessment.vessel_id"-->
                        <!--                                                        @change="crewAssessment.crew_activity_id = null"-->
                        <!--                                                >-->
                        <!--                                                    <option :value="null">-&#45;&#45; Select Vessel -&#45;&#45;</option>-->
                        <!--                                                    <option v-for="vesselKey in vesselKeys" :key="vesselKey.id"-->
                        <!--                                                            :value="vesselKey.id"-->
                        <!--                                                    >{{ vesselKey.name }}</option>-->
                        <!--                                                </select>-->

                        <input type="text" id="vessel_id" readonly
                               v-else
                               class="form-control form-control-xs"
                               placeholder="NO SPECIFIED VESSEL"
                               v-model="crewAssessment.vessel"
                        >
                        <span class="help-block" v-if="crewAssessmentError.vessel_id !== ''">
                                                    <small><strong>{{ crewAssessmentError.vessel_id }}</strong></small>
                                                </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': crewAssessmentError.crew_activity_id}"
                         v-if="editable">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="vessel_id">
                        Crew Activity:
                      </label>

                      <div class="col col-sm-8">
                        <select id="crew_activity_id"
                                class="form-control form-control-sm"
                                v-model="crewAssessment.crew_activity_id"
                                @change="crewAssessment.vessel_id = null"
                        >
                          <option :value="null">--- Select Crew Activity ---</option>
                          <option v-for="crewActivityKey in crewActivityKeys" :key="crewActivityKey.id"
                                  :value="crewActivityKey.id"
                          >{{ crewActivityKey.vesselWithDate }}
                          </option>
                        </select>
                        <span class="help-block" v-if="crewAssessmentError.crew_activity_id !== ''">
                                                    <small><strong>{{
                                                        crewAssessmentError.crew_activity_id
                                                      }}</strong></small>
                                                </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1"
                         v-if="editable"
                    >
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="crewAssessmentFile">
                        File:
                      </label>

                      <div class="col col-sm-8">
                        <input type="file" id="crewAssessmentFile"
                               class="form-control form-control-xs"
                               accept="application/pdf"
                        >
                      </div>
                    </div>

                    <hr/>
                    <template>
                      <button type="reset" v-if="editable"
                              @click.prevent="cancelEdit"
                              class="btn btn-sm btn-xs btn-secondary font-weight-bolder float-right"
                      >
                        CANCEL
                      </button>

                      <template template v-if="crew.active == 1 || isSystemAdmin">
                        <button type="submit" class="btn btn-sm btn-xs btn-warning font-weight-bolder float-right mr-2"
                                v-if="(isDesignatedPrincipal || isPrincipal || isPrincipalStaff) || (isDesignatedManning && !guest)"
                        >
                          <span class="fas fa-edit"></span>
                          {{ editable ? 'UPDATE' : 'EDIT' }}
                        </button>
                      </template>
                    </template>

                  </form>

                  <div class="col col-sm-12 p-3">
                    <h5 class="font-weight-bold">History</h5>
                    <table class="table table-hover table-bordered table-template-1 table-layout-fixed text-small">
                      <thead>
                      <tr>
                        <th class="p-2 col-index">#</th>
                        <th class="p-2">Vessel</th>
                        <th class="p-2">Updated By</th>
                        <template template v-if="crew.active == 1 || isSystemAdmin">
                          <template v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff">
                          <th class="p-2" style="width: 10%;">Del</th>
                          </template>
                        </template>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(crewAssessmentHistory, index) in crewAssessmentHistories"
                          :key="crewAssessmentHistory.id"
                          :class="{ 'bg-selected': crewAssessmentHistory.id === crewAssessment.id, 'cursor-pointer': crewAssessmentHistory.id !== crewAssessment.id }"
                          @click="getCrewAssessmentHistoryRecord(crewAssessmentHistory)"
                      >
                        <td>{{ index + 1 }}</td>
                        <td>{{ crewAssessmentHistory.vessel }}</td>
                        <td>{{ crewAssessmentHistory.updatedBy }}</td>
                        <template template v-if="crew.active == 1 || isSystemAdmin">
                          <template v-if="isDesignatedPrincipal || isPrincipal || isPrincipalStaff">
                          <td>
                            <button class="btn btn-outline-danger btn-xs" v-if="!guest"
                                    title="Delete this history record"
                                    @click="confirmDeleteCrewAssessmentHistory(crewAssessmentHistory.id)"
                            >
                              <i class="fas fa-trash"></i>
                            </button>
                          </td>
                          </template>
                        </template>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

              <div class="col col-sm-8 border-left">
                <div class="modal-header">
                  <h5 class="modal-title font-weight-bolder mx-auto" id="viewCrewDocumentTitle">
                    {{ assessmentTitle }}
                  </h5>
                  <button type="button" id="closeViewCrewAssessment" class="close p-0"
                          style="margin-left: -60px !important;"
                          data-dismiss="modal" aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>

                <iframe :src="crewAssessmentFile" frameborder="0" width="720" id="assessmentFrame"
                        class="full-height"
                        v-if="crewAssessment.hasFile"
                ></iframe>

                <div class="alert alert-danger" role="alert"
                     v-else
                >
                  NO UPLOADED DOCUMENT
                </div>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>

    <div class="modal fade"
         id="newCrewAssessment"
         tabindex="-1"
         role="dialog"
         aria-labelledby="newCrewDocumentTitle"
         aria-hidden="true"
    >
      <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
        <div class="modal-content">

          <div class="modal-body text-small full-modal-body-height">

            <div class="row">
              <div class="col col-sm-4">
                <div class="row">
                  <form class="col col-sm-12" @submit.prevent="confirmUploadCrewAssessment">

                    <div class="form-group form-row mb-1" :class="{'has-error': newCrewAssessmentError.conduct_date}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="newConductDate">
                        Conduct Date:
                      </label>

                      <div class="col col-sm-8">
                        <input type="date" id="newConductDate"
                               class="form-control form-control-xs"
                               v-model="newCrewAssessment.conduct_date"
                        >
                        <span class="help-block" v-if="newCrewAssessmentError.conduct_date !== ''">
                                                    <small><strong>{{
                                                        newCrewAssessmentError.conduct_date
                                                      }}</strong></small>
                                                </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': newCrewAssessmentError.place}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="newPlace">
                        Place:
                      </label>

                      <div class="col col-sm-8">

                        <select id="newPlace"
                                class="form-control form-control-sm"
                                v-model="newCrewAssessment.place"
                        >
                          <option :value="undefined">--- Select Place ---</option>
                          <option v-for="(assessmentReportPlace, index) in assessmentReportPlaces" :key="index"
                                  :value="assessmentReportPlace"
                          >{{ assessmentReportPlace }}
                          </option>
                        </select>

                        <!--                                                <input type="text" id="newPlace"-->
                        <!--                                                       class="form-control form-control-xs"-->
                        <!--                                                       placeholder="Enter Conducted Place Here"-->
                        <!--                                                       v-model="newCrewAssessment.place"-->
                        <!--                                                >-->
                        <span class="help-block" v-if="newCrewAssessmentError.place !== ''">
                                                    <small><strong>{{ newCrewAssessmentError.place }}</strong></small>
                                                </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1" :class="{'has-error': newCrewAssessmentError.vessel_id}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="newVessel_id">
                        Vessel:
                      </label>

                      <div class="col col-sm-8">

                        <VesselDropdown
                            id="newVessel_id"
                            v-model="newCrewAssessment.vessel_id"
                            :selections="vesselKeys"
                            identifier="newVessel"
                            :other-function="getOtherVesselKeys"
                        ></VesselDropdown>

                        <!--                                                <DropdownSelect id="newVessel_id"-->
                        <!--                                                                style="width: 80%"-->
                        <!--                                                                identifier="newVessel"-->
                        <!--                                                                :selections="vesselKeys"-->
                        <!--                                                                :other-function="getOtherVesselKeys"-->
                        <!--                                                                @updateNewVessel="newCrewAssessment.vessel_id = $event"-->
                        <!--                                                ></DropdownSelect>-->

                        <!--                                                <select id="newVessel_id"-->
                        <!--                                                        class="form-control form-control-sm"-->
                        <!--                                                        v-model="newCrewAssessment.vessel_id"-->
                        <!--                                                        @change="newCrewAssessment.crew_activity_id = null"-->
                        <!--                                                >-->
                        <!--                                                    <option :value="null">-&#45;&#45; Select Vessel -&#45;&#45;</option>-->
                        <!--                                                    <option v-for="vesselKey in vesselKeys" :key="vesselKey.id"-->
                        <!--                                                            :value="vesselKey.id"-->
                        <!--                                                    >{{ vesselKey.name }}</option>-->
                        <!--                                                </select>-->

                        <span class="help-block" v-if="newCrewAssessmentError.vessel_id !== ''">
                                                    <small><strong>{{
                                                        newCrewAssessmentError.vessel_id
                                                      }}</strong></small>
                                                </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1"
                         :class="{'has-error': newCrewAssessmentError.crew_activity_id}">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left" for="newCrew_activity_id">
                        Crew Activity:
                      </label>

                      <div class="col col-sm-8">
                        <select id="newCrew_activity_id"
                                class="form-control form-control-sm"
                                v-model="newCrewAssessment.crew_activity_id"
                                @change="newCrewAssessment.vessel_id = null"
                        >
                          <option :value="null">--- Select Crew Activity ---</option>
                          <option v-for="crewActivityKey in crewActivityKeys" :key="crewActivityKey.id"
                                  :value="crewActivityKey.id"
                          >{{ crewActivityKey.vesselWithDate }}
                          </option>
                        </select>
                        <span class="help-block" v-if="newCrewAssessmentError.crew_activity_id !== ''">
                                                    <small><strong>{{
                                                        newCrewAssessmentError.crew_activity_id
                                                      }}</strong></small>
                                                </span>
                      </div>
                    </div>

                    <div class="form-group form-row mb-1">
                      <label class="col col-sm-4 col-form-label font-weight-bolder text-left"
                             for="newCrewAssessmentFile">
                        File:
                      </label>

                      <div class="col col-sm-8">
                        <input type="file" id="newCrewAssessmentFile"
                               class="form-control form-control-xs"
                               accept="application/pdf"
                               @change="updateAssessmentFileFrame"
                        >
                      </div>
                    </div>

                    <hr/>
                    <template>

                      <button type="submit" class="btn btn-sm btn-xs btn-warning font-weight-bolder float-right mr-2">
                        <span class="fas fa-save"></span>
                        SAVE
                      </button>
                    </template>

                  </form>
                </div>
              </div>

              <div class="col col-sm-8 border-left">
                <div class="modal-header">
                  <h5 class="modal-title font-weight-bolder mx-auto" id="newCrewDocumentTitle">
                    {{ assessmentTitle }}
                  </h5>
                  <button type="button" id="closeNewCrewAssessment" class="close p-0"
                          style="margin-left: -60px !important;"
                          data-dismiss="modal" aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <span id="promptSpan"></span>
                <iframe frameborder="0" width="720" id="newAssessmentFrame"
                        class="full-height"
                ></iframe>

              </div>

            </div>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {vueAppMixin} from "@/mixins/vueAppMixin";
import {dataMixin} from "@/mixins/dataMixin";
import {gateMixin} from "@/mixins/gateMixin";
import {mapActions, mapGetters} from 'vuex';
import {ASSESSMENT_REPORT_PLACES} from "@/services/ConstantService";
// import DropdownSelect from "@/components/elements/DropdownSelect";
import VesselDropdown from "@/components/elements/VesselDropdown";
import AppLoading from "@/components/elements/AppLoading";

import {FileService} from "@/services/FileService";

export default {
  name: "CrewReport",
  mixins: [vueAppMixin, dataMixin, gateMixin],

  components: {
    VesselDropdown,
    AppLoading
    // DropdownSelect

  },

  data() {
    return {
      crewAssessment: {},
      crewAssessmentError: {},
      assessmentId: null,
      assessmentTitle: '',
      editable: false,
      newCrewAssessment: {},
      newCrewAssessmentError: {},
      assessmentReportPlaces: ASSESSMENT_REPORT_PLACES
    }
  },

  methods: {

    ...mapActions([
      'getCrewAssements',
      'getCrewAssessmentFile',
      'getVesselKeys',
      'updateCrewAssessment',
      'getCrewActivityKeys',
      'uploadCrewAssessment',
      'getCrewAssessmentHistory',
      'getOtherVesselKeys',
      'deleteCrewAssessmentHistory'
    ]),

    async confirmDeleteCrewAssessmentHistory(crewAssessmentId) {
      if (await this.confirmDeleteAlert()) {
        let params = {
          crewAssessmentId: crewAssessmentId
        }
        if (await this.deleteCrewAssessmentHistory(params)) {
          this.successAlert('Crew Assessment History Successfully Deleted', 'DELETE');
          if (this.crewAssessment.id === crewAssessmentId) {
            this.crewAssessment = Object.assign({}, this.crewAssessmentHistories[0]);
            this.assessmentId = this.crewAssessment.id;
          }
        }
      }

    },

    async initializeData() {
      await this.getCrewAssements({crewId: this.crew.id});
      if (this.isOchg && !this.isSystemAdmin) {
        let vesselParams = {
          manningId: this.crew.manning_id
        };
        await this.getVesselKeys(vesselParams);
      } else {
        await this.getVesselKeys();
      }
      await this.getCrewActivityKeys(this.crew.id);
    },

    refreshCrewAssessment() {
      this.crewAssessment = {};
      this.crewAssessmentError = {};
    },

    updateAssessmentModal(crewAssessment) {
      this.refreshCrewAssessment();
      this.crewAssessment = Object.assign({}, crewAssessment);
      this.assessmentId = this.crewAssessment.id;
      this.assessmentTitle = crewAssessment.documentName;
      this.getCrewAssessmentFile(this.crewAssessment.id);
      this.getCrewAssessmentHistory({
        crewId: this.crew.id,
        documentId: this.crewAssessment.documentId
      });
    },

    cancelEdit() {
      this.updateAssessmentModal(this.crewAssessments.find(crewAssessment => crewAssessment.id === this.crewAssessment.id));
      this.editable = false;
    },

    async confirmUpdateCrewAssessment() {
      if (this.editable) {
        if (await this.confirmUpdate()) {
          let formData = new FormData();

          formData.append('crewAssessmentId', this.crewAssessment.id);
          if (this.crewAssessment.conduct_date) formData.append('conduct_date', this.crewAssessment.conduct_date);
          if (this.crewAssessment.conduct_date) formData.append('place', this.crewAssessment.place);
          if (this.crewAssessment.crew_activity_id) {
            formData.append('crew_activity_id', this.crewAssessment.crew_activity_id);
          } else {
            formData.append('crew_activity_id', '');
          }
          if (this.crewAssessment.vessel_id) {
            formData.append('vessel_id', this.crewAssessment.vessel_id);
          } else {
            formData.append('vessel_id', '');
          }

          let input = document.getElementById('crewAssessmentFile');
          if (input.files && input.files[0]) {
            let file = input.files[0];
            formData.append('crewFile', file);
          }

          let updatedCrewAssessment = await this.updateCrewAssessment(formData);
          if (updatedCrewAssessment) {
            if (updatedCrewAssessment.errors) {
              this.crewAssessmentError = updatedCrewAssessment.errors;
            } else {
              document.getElementById('closeViewCrewAssessment').click();
              this.successAlert('Crew Assessment Successfully Updated', 'UPDATE');
              this.editable = false;
              this.crewAssessmentError = {};
            }
          }
        }
      } else {
        this.editable = true;
      }
    },

    refreshNewCrewAssessment(crewAssessment) {
      if (crewAssessment) {
        this.newCrewAssessment = {
          crew_id: this.crew.id,
          documentId: crewAssessment.documentId,
          vessel_id: null,
          crew_activity_id: null
        };
        this.assessmentTitle = crewAssessment.documentName;
      } else {
        this.newCrewAssessment = {crew_id: this.crew.id};
      }
      this.newCrewAssessmentError = {};
    },

    async confirmUploadCrewAssessment() {
      if (await this.confirmCreateAlert()) {
        let formData = new FormData();
        if (this.newCrewAssessment.conduct_date) formData.append('conduct_date', this.newCrewAssessment.conduct_date);
        if (this.newCrewAssessment.place) formData.append('place', this.newCrewAssessment.place);
        formData.append('crew_id', this.newCrewAssessment.crew_id);
        formData.append('document_id', this.newCrewAssessment.documentId);
        if (this.newCrewAssessment.crew_activity_id) {
          formData.append('crew_activity_id', this.newCrewAssessment.crew_activity_id);
        } else {
          formData.append('crew_activity_id', '');
        }
        if (this.newCrewAssessment.vessel_id) {
          formData.append('vessel_id', this.newCrewAssessment.vessel_id);
        } else {
          formData.append('vessel_id', '');
        }

        let input = document.getElementById('newCrewAssessmentFile');
        if (input.files && input.files[0]) {
          let file = input.files[0];
          formData.append('crewFile', file);
        }

        let newCrewAssessment = await this.uploadCrewAssessment(formData);
        if (newCrewAssessment) {
          if (newCrewAssessment.errors) {
            this.newCrewAssessmentError = newCrewAssessment.errors;
          } else {
            document.getElementById('closeNewCrewAssessment').click();
            this.successAlert('Crew Assessment Successfully Uploaded', 'UPLOAD');
            this.newCrewAssessmentError = {};
          }
        }

      }
    },

    updateAssessmentFileFrame() {
      let input = document.getElementById('newCrewAssessmentFile');
      if (input.files && input.files[0]) {
        if (input.files[0].size > 2000000) {
          document.getElementById('promptSpan').innerText = 'FILE TOO LARGE';
          this.clearIframe();
          return;
        } else {
          document.getElementById('promptSpan').innerText = '';
          let reader = new FileReader();
          reader.onload = function (e) {
            let file = FileService.base64FileToBlobUrl(e.target.result);
            document.getElementById('newAssessmentFrame').src = file;
            // document.getElementById('newAssessmentFrame').src  = e.target.result + "#zoom=80";
          };
          reader.readAsDataURL(input.files[0]);
        }
      } else {
        this.clearIframe();
      }
    },

    clearIframe() {
      document.getElementById('newAssessmentFrame').src = "";
    },

    async getCrewAssessmentHistoryRecord(crewAssessmentHistory) {
      if (this.crewAssessment.id !== crewAssessmentHistory.id) {
        this.crewAssessment = Object.assign({}, crewAssessmentHistory);
        this.getCrewAssessmentFile(this.crewAssessment.id);
      }
    },

    selectDocuments(source) {
      this.crewAssessments.forEach(assessment => {
        if (assessment.hasFile) {
          if (source.target.checked) {
            this.printMultipleParams.selectedCrewDocuments.assessments.push(assessment.id);
          } else {
            this.printMultipleParams.selectedCrewDocuments.assessments = this.printMultipleParams.selectedCrewDocuments.assessments.filter(assessmentId => {
              assessmentId != assessment.id
            });
          }
        }
      });
    }
  },

  created() {
    this.initializeData();
  },
  computed: {

    ...mapGetters([
      'crewAssessments',
      'crewAssessmentFile',
      'crew',
      'vesselKeys',
      'crewActivityKeys',
      'crewAssessmentHistories',
      'printMultipleParams'
    ]),

    emptyHistory() {
      let empty = [];
      for (let i = this.crewDocumentHistory.length + 1; i <= 3; i++) {
        empty.push(i);
      }
      return empty;
    },

    allSelected() {
      let allSelected = true;
      this.crewAssessments.forEach(assessment => {
        if (assessment.hasFile) {
          if (!this.printMultipleParams.selectedCrewDocuments.assessments.includes(assessment.id)) {
            allSelected = false;
          }
        }
      });
      return allSelected;
    }
  }
}
</script>

<style scoped>
* {
  font-family: 'Nunito', sans-serif;
}

.table-template-1 td, .table-template-1 {
  text-align: center;
}

.table-template-1 td:nth-child(3) {
  text-align: left;
}
</style>
